import { render, staticRenderFns } from "./dr-text-area-spilka-ui-kit.vue?vue&type=template&id=4fa57655&"
import script from "./dr-text-area-spilka-ui-kit.vue?vue&type=script&lang=js&"
export * from "./dr-text-area-spilka-ui-kit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports